import {
  CaloriesBox,
  FoodImageBox,
  MealName,
  MealNutrient,
  ScheduleItemInfo,
  ScheduleItemWrapper,
  SchedulePeriod,
  SmallWeekDayOption,
} from "./styled"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import { getDisplayCalories, getDisplayPortion } from "utils"
import { capitalizeFirstLetter, formatUnit } from "utils/formater"
import dayjs from "dayjs"
import { FlexBox } from "components/Common/FlexBox"
import { DAYS_OF_WEEK } from "config"
import { ISchedule } from "model/food/types/schedule.types"
import { isEdamaMeal } from "model/food/utils/typeGuards/mealTypeGuards"

const formatScheduleDate = (startDate: string, endDate?: string) => {
  const start = dayjs.utc(startDate).local().format("MMM DD")
  if (!endDate) return start

  const end = dayjs.utc(endDate).local().format("MMM DD")
  return `${start} - ${end}`
}

const ScheduleItem = ({
  schedule,
  onGoToDetails,
}: {
  schedule: ISchedule
  onGoToDetails: (schedule: ISchedule) => void
}) => {
  const {
    meal: { name, imageUrl, calorie, unit, portion, type },
    type: scheduleType,
    startDate,
    endDate,
    daysOfWeek,
  } = schedule
  return (
    <ScheduleItemWrapper onClick={() => onGoToDetails(schedule)}>
      <FoodImageBox>
        <SmallFoodImage src={imageUrl} />
      </FoodImageBox>

      <ScheduleItemInfo>
        <MealName>{name}</MealName>
        <CaloriesBox>
          <MealNutrient>
            {getDisplayCalories(calorie)} cal, {getDisplayPortion(portion)}{" "}
            {formatUnit(unit, isEdamaMeal(schedule.meal))}{" "}
          </MealNutrient>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="5"
            viewBox="0 0 4 5"
            fill="none"
          >
            <circle cx="2" cy="2.5" r="2" fill="#00263A" fillOpacity="0.32" />
          </svg>

          {type && (
            <MealNutrient>
              {capitalizeFirstLetter(type.toLowerCase())}
            </MealNutrient>
          )}
        </CaloriesBox>

        <SchedulePeriod>
          {scheduleType !== "CUSTOM" ? (
            <span>{scheduleType === "DAILY" ? "Daily" : "Weekly"}</span>
          ) : (
            <span>{formatScheduleDate(startDate, endDate)}</span>
          )}

          {!!daysOfWeek.length ? (
            <FlexBox style={{ marginLeft: "auto" }} $gap={6}>
              {" "}
              {DAYS_OF_WEEK.map((day) => (
                <SmallWeekDayOption
                  key={day}
                  $isSelected={daysOfWeek.includes(day)}
                >
                  {day.slice(0, 1)}
                </SmallWeekDayOption>
              ))}
            </FlexBox>
          ) : null}
        </SchedulePeriod>
      </ScheduleItemInfo>
    </ScheduleItemWrapper>
  )
}

export default ScheduleItem
